import { authFetch } from "./api";

export type Company = {
  id: string
  sapCode: string;
  legalEntity: string;
  perimeter: string;
  region: string;
  country: string;
  business: string;
  regionalCFO?: string;
  countryFinanceManager?: string;
  personeRuoliCompanies: PersonaRuoloCompany[];
};

export type PersonaRuoloCompany = {
  companyId:string;
  personEmail: string;
  role: string
};

export const getCompanies = async () => {
  try {
    const url = `${import.meta.env.VITE_API_URL}/companies`;
    const response = await authFetch(url, {
      method: "GET",
    });

    const json = await response.json();
    if (!response.ok) {
      throw new Error(json.message || "Failed to fetch companies");
    }
    return { data: json, error: null };

  } catch (error) {
    if (error instanceof Error) {
      return { data: null, error: error.message };
    }
    return { data: null, error: "An unknown error occurred" };
  }
}